export default "__VITE_PUBLIC_ASSET__cadffc58__"